<div>
    <div *ngIf="editing">
      <input #inlineEditControl [required]="required" (blur)="onBlur($event)" [name]="value" [(ngModel)]="value" [type]="type" [placeholder]="label" [ngStyle]="{'width':'100%','font-size':fontSize, 'letter-spacing':letterSpacing}" />
    </div>
    <div *ngIf="!editing">
      <!-- <label class="block bold">{{label}}</label> -->
      <div title="Click to edit" (click)="edit(value)" (focus)="edit(value);" tabindex="0" class="inline-edit" [ngStyle]="{'font-size':fontSize, 'letter-spacing':letterSpacing}">{{value}}&nbsp;</div>
    </div>
  </div>